export default __webpack_public_path__ + "static/media/pr_c_26.27ee78b3.jpg";